var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"apexChartWrapper",attrs:{"color":_vm.$vuetify.theme.dark ? '#162334' : '#E8F1F8'}},[_c('div',{attrs:{"id":"chart-wrap"}},[_c('div',{ref:"chart",attrs:{"id":"chart"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }